<template>
	<div class="map_box_block">

		<div class="map_box">
			<yandex-map ref="map" style="width: 100%; height: 40vh;"
						:coords="[57.527454, 39.737447]"
						:zoom="13"
						:controls="['zoomControl',]"
						:scrollZoom="false"
						@map-was-initialized="onMapInitialized"
			>
				<ymap-marker markerId="1" :coords="[57.527454, 39.737447]"></ymap-marker>
			</yandex-map>
		</div>
	</div>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
// import { yandexMap } from 'vue-yandex-maps';

import yamap_settings_json from '../assets/json/yamapcustom.json'


export default {

	name: "MapComponent",
	components: {
		yandexMap,
		ymapMarker,
	},
	mounted() {
		// <script src="https://api-maps.yandex.ru/2.1/?lang=ru_RU" type="text/javascript">
		// let ymap_api = document.createElement('script')
		// ymap_api.setAttribute('src', 'https://api-maps.yandex.ru/2.1/?lang=ru_RU')
		// document.head.appendChild(ymap_api)

		// const script = document.createElement('script');
		// script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
		// script.async = true;
		// document.body.appendChild(script);

		// script.onload = () => {
		// 	console.log('Script loaded successfully.');
		// };

		// script.onerror = () => {
		// 	console.error('Failed to load script.');
		// };


	},
	data() {
		return {
			ymaps: null,
			mapCoverVisible: true,
			yamap_settings_json: yamap_settings_json,
		}
	},
	methods: {
		// async loadGeoJSONData() {
		// 	return this.ymaps.geoObjects.add(yamap_settings_json);
		// },

		onMapInitialized(map) {
			this.ymaps = map
			// console.info(this.ymaps.geoObjects)
			// console.info(Object.getOwnPropertyNames(yandexMap).filter(prop => typeof yandexMap[prop] === 'function'))

			// this.ymaps
			// this.ymaps.layers.add(yamap_settings_json)
			// console.info('ymaps', this.ymaps)
			// console.info('this.ymaps.GeoJSON', this.ymaps.DefaultSchemeLayer)
			// const layer = new map.GeoJSON(yamap_settings_json);
			// this.ymaps.geoObjects.add(layer)


			// this.ymaps.controls.add('typeSelector')
			// this.ymaps.controls.remove('typeSelector')
			// this.ymaps.controls.remove('fullscreenControl')
			// this.ymaps.controls.remove('rulerControl')

			// console.info('this.ymaps.layer:', this.ymaps.layer)
			// this.ymaps.addChild(new this.yandexMap.DefaultSchemeLayer(this.yamap_settings_json));

		},
	},
}
</script>

<style >
/*#yandexMap1099 {*/
	/*mix-blend-mode: exclusion;*/
/*}*/
.ymaps-2-1-79-inner-panes {
	/*background-image: linear-gradient(#000000, #000000), linear-gradient(#ffffff, #ffffff);*/
	/*background-blend-mode: exclusion, hard-light;*/
	-ms-filter: grayscale(1);
    -webkit-filter: grayscale(1);
    -moz-filter: grayscale(1);
    -o-filter: grayscale(1);
    filter: grayscale(1);
}
.map_box_block {
	position: relative;
	min-height: 30vh;
	width: 100%;
}
.map_box {
	/*background-image: linear-gradient(#5b5959, #5b5959), linear-gradient(#d3d3d3, #d3d3d3);*/
	/*background-blend-mode: exclusion, hard-light;*/

    position: relative;
    width: 100%;
    display: flex;
    flex-direction: revert;
    padding-top: 1em;
}
.map_cover {
	cursor: pointer;
	position: absolute;
	top: 0; bottom: 0;
	left: 0; right: 0;
	background-color: rgba(125, 125, 125, 0.1);
}
.map_cover > div {
    margin: auto;
    display: flex;
    flex-direction: column;
    height: 100%;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
	font-size: 22px;
	opacity: 0.2;

}
.map_cover > div > span {
	padding: 0.5em 1em;
    /*border: 1px solid black;*/
    border-radius: 7px;
    background-color: #00000017;
}
.ymap-container {
	width: 100%;
	height: 100%;
	padding: 0px;
}


.ymaps-2-1-79-copyright__wrap, [class*="-copyright__wrap"], [class*="-gototech"] {
  display: none !important;
}
</style>